import { type IBrokerContext } from '../../context'
import { type IBrokerPlugin } from '../plugin'

const BrokerPluginInstallTypes = {
  script: 'script',
  local: 'local'
} as const

export type BrokerPluginInstallType = typeof BrokerPluginInstallTypes[keyof typeof BrokerPluginInstallTypes]

export interface BrokerPluginInstallOption <TYPE extends BrokerPluginInstallType> {
  type: TYPE
}

export interface IBrokerPluginInstaller<TYPE extends BrokerPluginInstallType, OPTION extends BrokerPluginInstallOption<TYPE> = BrokerPluginInstallOption<TYPE>> {
  install(ctx: IBrokerContext, installOption: OPTION): Promise<IBrokerPlugin>
  uninstall(module: IBrokerPlugin, ctx: IBrokerContext): Promise<void>
}

export function createPluginContext<T extends BrokerPluginInstallType> (id: string, ctx: IBrokerContext, installOption: BrokerPluginInstallOption<T>) {
  return {
    apis: ctx.apis,
    logger: ctx.logger,
    brokerEventEmitter: ctx.eventEmitter,
    eventEmitter: ctx.rootMessenger.createLocalEmitter(id)
  }
}
